class EasyStorage {
  storage

  constructor (storage) {
    if (storage === 'session') {
      this.storage = window.sessionStorage
    } else {
      this.storage = window.localStorage
    }
  }

  get (key) {
    const value = this.storage.getItem(key)

    if (typeof value !== 'string') {
      return value
    }

    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  }

  set (key, value) {
    const str = JSON.stringify(value)
    this.storage.setItem(key, str)
  }

  remove (key) {
    this.storage.removeItem(key)
  }

  clear () {
    this.storage.clear()
  }
}

const storage = new EasyStorage('local')

storage.session = new EasyStorage('session')

/**
 * 快速自动化存储并解析 storage 数据，不需要手动 JSON.parse / JSON.stringify
 * 默认使用 localStorage, sessionStorage 可以通过 storage.session 调用
 */
export default storage
